import { createIcon } from '@chakra-ui/react';

export const MixedPlaylistTypeIllustration = createIcon({
  displayName: 'SingleDisplayIllustration',
  viewBox: '0 0 151 151',
  defaultProps: {
    fill: 'none',
    width: '151px',
    height: '151px',
  },
  path: (
    <>
      <circle cx="75.4385" cy="75.6846" r="74" fill="#F0F4F8" stroke="#0F5291" strokeWidth="2" />
      <g filter="url(#filter0_dd_413_61016)">
        <path
          d="M32.1025 54.0196C32.1025 51.565 34.0924 49.5752 36.547 49.5752H114.325C116.779 49.5752 118.769 51.565 118.769 54.0196V99.5752C118.769 102.03 116.779 104.02 114.325 104.02H36.547C34.0924 104.02 32.1025 102.03 32.1025 99.5752V54.0196Z"
          fill="black"
        />
        <path
          d="M54.3247 104.02H98.2136V105.131C98.2136 106.358 97.2187 107.353 95.9914 107.353H56.547C55.3197 107.353 54.3247 106.358 54.3247 105.131V104.02Z"
          fill="black"
        />
        <path
          d="M97.1025 105.131C97.1025 105.744 96.6048 106.242 95.9912 106.242H56.5469C55.9333 106.242 55.4356 105.744 55.4355 105.131H97.1025ZM36.5469 50.6865H114.325C116.166 50.6868 117.658 52.1788 117.658 54.0195V99.5752C117.658 101.416 116.166 102.908 114.325 102.908H36.5469C34.706 102.908 33.2139 101.416 33.2139 99.5752V54.0195C33.2139 52.1787 34.706 50.6866 36.5469 50.6865Z"
          stroke="#0F5291"
          strokeWidth="2.22222"
        />
      </g>
      <path
        d="M63.4385 66.6846H45.4385C44.4385 66.6846 43.4385 67.6846 43.4385 68.6846V82.6846C43.4385 83.7846 44.3385 84.6846 45.4385 84.6846H63.4385C64.4385 84.6846 65.4385 83.6846 65.4385 82.6846V68.6846C65.4385 67.6846 64.4385 66.6846 63.4385 66.6846ZM63.4385 82.6046C63.4185 82.6346 63.3785 82.6646 63.3585 82.6846H45.4385V68.7646L45.5185 68.6846H63.3485C63.3785 68.7046 63.4085 68.7446 63.4285 68.7646V82.6046H63.4385ZM53.4385 79.1946L50.9385 76.1846L47.4385 80.6846H61.4385L56.9385 74.6846L53.4385 79.1946Z"
        fill="#4B9EEC"
      />
      <path
        d="M98.4385 71.6846V79.6846H88.4385V71.6846H98.4385ZM99.4385 69.6846H87.4385C86.8885 69.6846 86.4385 70.1346 86.4385 70.6846V80.6846C86.4385 81.2346 86.8885 81.6846 87.4385 81.6846H99.4385C99.9885 81.6846 100.438 81.2346 100.438 80.6846V77.1846L104.438 81.1846V70.1846L100.438 74.1846V70.6846C100.438 70.1346 99.9885 69.6846 99.4385 69.6846Z"
        fill="#4B9EEC"
      />
      <defs>
        <filter
          id="filter0_dd_413_61016"
          x="23.8086"
          y="48.1929"
          width="103.255"
          height="74.3658"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feMorphology
            radius="1.38233"
            operator="erode"
            in="SourceAlpha"
            result="effect1_dropShadow_413_61016"
          />
          <feOffset dy="2.76465" />
          <feGaussianBlur stdDeviation="2.07349" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0.219608 0 0 0 0 0.372549 0 0 0 0.05 0"
          />
          <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_413_61016" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feMorphology
            radius="2.07349"
            operator="erode"
            in="SourceAlpha"
            result="effect2_dropShadow_413_61016"
          />
          <feOffset dy="6.91164" />
          <feGaussianBlur stdDeviation="5.18373" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0.219608 0 0 0 0 0.372549 0 0 0 0.1 0"
          />
          <feBlend
            mode="normal"
            in2="effect1_dropShadow_413_61016"
            result="effect2_dropShadow_413_61016"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect2_dropShadow_413_61016"
            result="shape"
          />
        </filter>
      </defs>
    </>
  ),
});
